import { render, staticRenderFns } from "./brand-value.vue?vue&type=template&id=ed0faea8&"
import script from "./brand-value.vue?vue&type=script&lang=js&"
export * from "./brand-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports